import { useCallback, useContext } from 'react';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import ModalContext from '~/context/vdp/ModalContext';

export enum SoftPullLocations {
  Composer = 'Composer'
}

export function useOpenSoftPullModal(location: SoftPullLocations) {
  const { setSoftPullModalOpen } = useContext(ModalContext);
  const trackEvent = useTrackEvent();

  return useCallback(() => {
    setSoftPullModalOpen(true);
    trackEvent('MerchUI Opened Soft Pull Modal', {
      openLocation: location
    });
  }, [location, setSoftPullModalOpen, trackEvent]);
}
